import { render, staticRenderFns } from "./list_dropdown_brand.vue?vue&type=template&id=8a1bd15e&"
import script from "./list_dropdown_brand.vue?vue&type=script&lang=js&"
export * from "./list_dropdown_brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports